
import RSIUpgrade from '@share/assets/images/profiles/footer-rsi-upgrade.png';

import RsiGetaways1 from '@share/assets/images/profiles/rsi-getaways-1.jpg';
import RsiGetaways2 from '@share/assets/images/profiles/rsi-getaways-2.jpg';
import RsiGetaways3 from '@share/assets/images/profiles/rsi-getaways-3.jpg';
import RsiGetaways4 from '@share/assets/images/profiles/rsi-getaways-4.jpg';
import RsiGetaways5 from '@share/assets/images/profiles/rsi-getaways-5.jpg';
import RsiGetaways6 from '@share/assets/images/profiles/rsi-getaways-6.jpg';
import RsiGetaways7 from '@share/assets/images/profiles/rsi-getaways-7.jpg';
import RsiGetaways8 from '@share/assets/images/profiles/rsi-getaways-8.jpg';
import RsiGetaways9 from '@share/assets/images/profiles/rsi-getaways-9.jpg';
import RsiGetaways10 from '@share/assets/images/profiles/rsi-getaways-10.jpg';
import RsiGetaways11 from '@share/assets/images/profiles/rsi-getaways-11.jpg';

export const RSIUpgradeEliteProfile = {
    logo: RSIUpgrade,
    logoSkipWidth: true,

    headerFontColor: '#FFFFFF',
    headerBackgroundColor: '#7A061F',

    buttonColor: '#B0231C',
    buttonTextColor: '#FFFFFF',

    buttonColorReverse: '#FFFFFF',
    buttonTextColorReverse: '#B0231C',

    buttonBorderRadius: '0',

    generalBorderRadius: '0',
    generalBorderColor: '#0079C2',
    
    isTravelLeadersImage: true,
    travelLeadersImages: [
        { value : RsiGetaways1 },
        { value : RsiGetaways2 },
        { value : RsiGetaways3 },
        { value : RsiGetaways4 },
        { value : RsiGetaways5 },
        { value : RsiGetaways6 },
        { value : RsiGetaways7 },
        { value : RsiGetaways8 },
        { value : RsiGetaways9 },
        { value : RsiGetaways10 },
        { value : RsiGetaways11 },
    ],
    travelLeadersImageBackground: '#7A061F',
    travelLeadersImageTextHide: true,
    travelLeadersImageTextColor: '#FFFFFF',
    //travelLeadersImageTextPosition: 'bottom-under',
    //travelLeadersImageTextPosition: 'bottom',
    //travelLeadersImageTextPosition: 'top',
    //travelLeadersImageTextPosition: 'center',
    //travelLeadersImageText: 'rsi.upgrade.prime.hero.text',

    bogoColor: '#323232',
    bogoButtonTextColor: '#7A061F',
    getawaysColor: '#7A061F',
    getawaysButtonTextColor: '#7A061F',

    buttonColorAlternative: '#CFA241',
    buttonTextColorAlternative: '#FFFFFF',

    mainBackgroundColor: '#7A061F',
    subHeaderColor: '#000000',
    travelLeadersFontSize: '50',

    mainBorderColor: '#6D6D6D',
    mainBorderRadius: '0',
    mainHideLinkIcon: true,

    menuItemHideBorderBottom: true
}
